import * as React from 'react';

import i18n from 'helper/i18n';

import Coach from 'components/atoms/Coach';
import Link from 'components/atoms/Link';
import LoginButton from 'components/molecules/LoginButton';

export type LoginProps = {
	impulsCoachBaseLink: {
		href: string;
	};
	isMigrosAuthenticated: boolean;
	doClearRedirectRoutePath: () => {};
	doChangeMigrosLoginStatus: (status: string, attempted?: boolean) => {};
	migrosLoginReturnToURL: string;
	migrosLogoutReturnToURL: string;
};

const label = (key: string): string => {
	return i18n(`react.impulsCoach.components.login.${key}`);
};

export default class Login extends React.Component<LoginProps> {
	public static displayName = 'Login';

	public render() {
		const {
			impulsCoachBaseLink,
			isMigrosAuthenticated,
			doChangeMigrosLoginStatus,
			doClearRedirectRoutePath,
			migrosLoginReturnToURL,
			migrosLogoutReturnToURL,
		} = this.props;

		return (
			<div className="m-login">
				<div className="m-login__wrapper">
					<div className="m-login__rectangle-top">
						<div className="m-login__triangle-left" />
						<div className="m-login__triangle-right" />
						<div className="container container--full-width-ms">
							<div className="row">
								<div className="col-xs-12">
									<div className="m-login__head col-sm-10">
										<h2 className="m-login__head-title">{label('title')}</h2>
										<p className="m-login__head-intro">{label('introText')}</p>
										<div className="m-login__head-register">
											<LoginButton
												bigButton
												showLoginButton
												showUserData={false}
												setupLoginFlow={undefined as any}
												isMigrosAuthenticated={isMigrosAuthenticated}
												doChangeMigrosLoginStatus={doChangeMigrosLoginStatus}
												doClearRedirectRoutePath={doClearRedirectRoutePath}
												migrosLoginReturnToURL={migrosLoginReturnToURL}
												migrosLogoutReturnToURL={migrosLogoutReturnToURL}
											/>
										</div>
									</div>
									<div className="m-login__info col-sm-11">
										<p className="m-login__info-text">{label('infoText')}</p>
										<div className="m-login__info-button">
											<Link
												externalHref={impulsCoachBaseLink.href}
												modifier="button-green"
												title={label('infoButtonText')}
											/>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="m-login__coach-box">
					<div className="m-login__coach-wrap">
						<Coach coach={'mia' as any} gesture="full-good" alt="" />
					</div>
				</div>
			</div>
		);
	}
}
